import React from "react";
import { LabService } from "../../services/labService";

interface CertificationDownloadsProps {
    certificateId: string;
    level: "bronze" | "silver" | "gold";
}

const levelLabel = (level: CertificationDownloadsProps["level"]) =>
    level.charAt(0).toUpperCase() + level.slice(1);

export const CertificationDownloads: React.FC<CertificationDownloadsProps> = ({
    certificateId,
    level,
}) => {
    return (
        <div className="space-y-4">
            <div className="flex gap-4 flex-wrap">
                <a
                    href={LabService.getCertificateUrl(certificateId)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                >
                    Download {levelLabel(level)} Certificate
                </a>
                <a
                    href={LabService.getBannerUrl(certificateId)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                >
                    Download {levelLabel(level)} Banner
                </a>
            </div>
        </div>
    );
};
